import {TableDefinition} from '../../models';

export const SPECIALIZATION_TABLE_DEFINITION: TableDefinition = [
  {
    key: 'API.fields.Specialization.id',
    prop: 'id',
    visible: false,
    objectName: 'Specialization',
    searchFieldType: 'NUMBER',
  },
  {
    key: 'API.fields.Specialization.name',
    prop: 'name',
    visible: true,
    objectName: 'Specialization',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Specialization.contactListTotal',
    prop: 'contactListTotal',
    visible: true,
    sortDisabled: true,
  },
];
